import React, { useCallback, useEffect } from 'react';
import ServiceBell from '@servicebell/widget';
import { Button } from 'shared/components/Button';
import { AttentionIcon } from 'browser/components/Dashboard/icons';
import { InlineModal } from 'browser/components/InlineModal';
import './style.less';
import { contactSales } from 'shared/utils/sales';

interface LimitModalProps {
  isVisible: boolean;
  title: string;
  subtitle: React.ReactNode;
  closeText: React.ReactNode;
  onClose(): void;
}

export const LimitModal: React.FC<LimitModalProps> = ({
  isVisible,
  title,
  subtitle,
  closeText,
  onClose,
}) => {
  useEffect(() => {
    if (!isVisible) return;

    ServiceBell('alert', { title, body: 'The visitor has reached their plan limit' });
  }, [isVisible, title]);

  const handleUpgrade = useCallback(() => {
    onClose();
    contactSales({ subject: `Upgrade Plan: ${title}` });
  }, [onClose, title]);

  return (
    <InlineModal visible={isVisible} onCancel={onClose} className="LimitModal">
      <AttentionIcon />
      <h1 className="LimitModal__title">{title}</h1>
      <p className="LimitModal__subtitle">{subtitle}</p>
      <Button
        className="LimitModal__btn"
        type="primary"
        size="large"
        onClick={handleUpgrade}
      >
        Upgrade plan
      </Button>
      <Button type="link" onClick={onClose} className="LimitModal__link">
        {closeText}
      </Button>
    </InlineModal>
  );
};
